import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PROMPT_EXAMPLES } from "../lib/homevision";
import { fadeUp, viewportOnce } from "../lib/motion";

const VisionPrompts = () => {
    const [active, setActive] = useState(0);
    const current = PROMPT_EXAMPLES[active];

    return (
        <section
            data-testid="vision-prompts"
            className="relative border-t border-white/10 bg-surface/40 py-24 lg:py-36"
        >
            <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
                <div className="grid items-center gap-14 lg:grid-cols-12">
                    <div className="lg:col-span-5">
                        <motion.div
                            variants={fadeUp}
                            initial="hidden"
                            whileInView="show"
                            viewport={viewportOnce}
                        >
                            <p className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-mist">
                                <span className="h-1.5 w-1.5 bg-accent" />
                                NATURAL LANGUAGE
                            </p>
                            <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.1] text-white md:text-5xl">
                                IN PLAIN LANGUAGE
                                <span className="text-accent">.</span>
                            </h2>
                            <p className="mt-5 max-w-sm text-[16px] leading-relaxed text-mist">
                                Describe a change in your own words and explore
                                a new concept direction.
                            </p>
                        </motion.div>

                        <motion.div
                            variants={fadeUp}
                            initial="hidden"
                            whileInView="show"
                            viewport={viewportOnce}
                            className="mt-10 space-y-3"
                        >
                            {PROMPT_EXAMPLES.map((p, i) => (
                                <button
                                    key={p.tag}
                                    type="button"
                                    data-testid={`vision-prompt-${i + 1}`}
                                    onClick={() => setActive(i)}
                                    className={`block w-full border-l-2 px-5 py-4 text-left font-mono text-[15px] leading-relaxed transition-all duration-300 ${
                                        active === i
                                            ? "border-accent bg-white/[0.04] text-white"
                                            : "border-white/10 text-mist hover:border-white/30 hover:text-white"
                                    }`}
                                >
                                    {p.q}
                                </button>
                            ))}
                            <p className="pt-2 font-mono text-[13px] tracking-[0.2em] text-mist">
                                EXAMPLE INTERACTIONS — ILLUSTRATIVE
                            </p>
                        </motion.div>
                    </div>

                    <motion.div
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="show"
                        viewport={viewportOnce}
                        className="lg:col-span-7"
                    >
                        <div
                            data-testid="vision-prompt-frame"
                            className="relative aspect-[4/3] overflow-hidden border border-white/10 bg-surface"
                        >
                            <AnimatePresence mode="wait">
                                <motion.img
                                    key={active}
                                    src={current.image}
                                    alt={current.alt}
                                    initial={{ opacity: 0, scale: 1.025 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.55, ease: "easeOut" }}
                                    className="absolute inset-0 h-full w-full object-cover"
                                />
                            </AnimatePresence>
                            <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" />
                            <div className="absolute inset-x-0 bottom-0 flex items-center justify-between p-6">
                                <p className="font-mono text-[13px] tracking-[0.22em] text-white/85">
                                    {current.tag}
                                </p>
                            </div>
                            <span className="absolute right-5 top-5 flex gap-1.5">
                                {PROMPT_EXAMPLES.map((_, i) => (
                                    <span
                                        key={i}
                                        className={`h-1 w-6 transition-colors duration-300 ${
                                            i === active
                                                ? "bg-accent"
                                                : "bg-white/25"
                                        }`}
                                    />
                                ))}
                            </span>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default VisionPrompts;
